'use strict';

import { schema } from './schema.fn';

schema.$inject = ['fieldDefinitionService', 'htmlService', 'dateUtils', '$window', 'configuration'];
angular.module('kerp-forms.forms').factory('NL_FCA_SCHEMA', schema);
